import {ref, watch} from 'vue'
import {defineStore} from 'pinia'
import interactionsPlugin from '@fullcalendar/interaction';
import getCalendarOptions from '@/js/api/CalendarOptions';

export const useCalendarStore = defineStore('calendarStore', () => {
    const locale = document.documentElement.lang || 'no';

    const calendarOptions = ref({});
    const apiLoaded = ref(false);
    const productResponse = ref([]);
    const categories = ref([]);
    const products = ref([]);
    const currentCategory = ref(null);
    const currentProduct = ref(null);

    watch (currentCategory, (categoryId) => {
        products.value = [];
        products.value = productResponse.value.filter(product => {
            return product.web_category_id === categoryId;
        });

        // Auto select same product if it exists in new category
        if (currentProduct.value) {
            const exists = products.value.find(product => {
                return product.product_id === currentProduct.value.product_id
            });
            if (!exists) {
                currentProduct.value = null;
            } else {
                currentProduct.value = exists
            }
        }
    });

    async function loadFilters() {
        const data = await window.TABS.calendar.getFilterOptions()

        productResponse.value = data.products[window.officeId]
        categories.value = TABS.calendar.getClassSelectOptions(productResponse.value)
    }

    const apiLoadedInterval = window.setInterval(() => {
        if (window.TABS && window.TABS.api.isLoaded) {
            const d = new Date();
            calendarOptions.value = {...getCalendarOptions(d, locale, 'standard')}
            calendarOptions.value.validRange = {
                start: d,
            }
            calendarOptions.value.plugins = [interactionsPlugin, ...calendarOptions.value.plugins];
            window.clearInterval(apiLoadedInterval);
            apiLoaded.value = true;

            // Initialize calendar filters
            loadFilters();
        }
    }, 50);

    return {
        apiLoaded,
        categories,
        products,
        currentProduct,
        currentCategory,
        calendarOptions
    }
});